import React, { useState } from "react";
import { Modal } from "antd";
import Input from "../../shared/input";
import Buttoon from "../../components/buttoon";
import axios from "axios";
import Swal from "sweetalert2";

const ChangeDepModal = ({ isdepModalOpen, setIsdepModalOpen, fetchLoginUser }) => {
  const [newDepartment, setNewDepartment] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    setIsdepModalOpen(false);
    console.log("Modal should close now");
  };

  const handleChangeDepartment = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/update_department`,
        { department: newDepartment },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Department updated successfully", response.data);
      setLoading(false);
      fetchLoginUser(); 
      handleCancel();
      Swal.fire({
        title: "Success",
        text: "Your department has been updated successfully!",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("Error updating department:", error);
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "There was an error updating your department. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <Modal
      open={isdepModalOpen}
      className="credit-modal"
      centered={true}
      onCancel={handleCancel}
      footer={null}
    >
      <div className="modal-content">
        <div className="pass-modal-header w-100">
          <h4 className="fw-bold">Change Department</h4>
        </div>
        <div className="pass-modal-content">
          <div className="c-pass-div h-center justify-content-start flex-column gap-2">
            <label className="fw-bold" htmlFor="">
              Enter Your Department
            </label>
            <Input
              height="46px"
              type="text"
              className="curnt-pass w-100"
              value={newDepartment}
              onChange={(e) => setNewDepartment(e.target.value)}
            />
          </div>

          <div className="h-center">
            <Buttoon
              className="btn btn-primary mt-5 m-auto"
              minWidth={166}
              minHeight={43}
              text="Save"
              onClick={handleChangeDepartment}
              loading={loading}
            ></Buttoon>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ChangeDepModal;
